/* Angular */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/* Components */
import { PublicComponent } from './components/public';

/* Modules */
import { SharedModule } from '../shared/shared.module';

/*TESTING*/
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
/*TESTING*/

/* Routes @todo pick if it is here or in route file for module. */
const routes = [ 
    { path:"publicView", component:PublicComponent}
];

@NgModule({
    imports : [
        SharedModule,
        NgbModule, //TESTING
        RouterModule.forChild(routes)
    ],
    declarations : [
        PublicComponent
    ],
    providers : [

    ],
    exports : [
        RouterModule
    ]
})
export class PublicModule{

}